if (!window.buyNowInitialized) {
  window.buyNowInitialized = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const form = button.form;
    if (!form) return;

    const addButton = form.querySelector('[name="add"]');
    if (addButton && addButton.disabled) return;

    // Required details on the page (e.g. an account email) are checked first, wherever they sit
    if (!form.reportValidity()) return;

    const formData = new FormData(form);
    const variantId = formData.get('id');
    if (!variantId) return;

    const quantity = Math.max(parseInt(formData.get('quantity'), 10) || 1, 1);
    const hasDetails = [...formData.keys()].some((key) => key.startsWith('properties['));

    const setLoading = (loading) => {
      if (loading) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
      button.classList.toggle('loading', loading);
      button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
    };
    setLoading(true);

    if (!hasDetails) {
      window.location.href = `${window.routes.cart_url}/${variantId}:${quantity}`;
      return;
    }

    // Line item details can't ride on the instant checkout link, so add the item with them, then
    // go to checkout. If that fails, fall back to Add to cart, which shows the error message.
    fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) throw new Error('add failed');
        window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
      })
      .catch(() => {
        setLoading(false);
        addButton?.click();
      });
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-buy-now].loading').forEach((button) => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      button.querySelector('.loading__spinner')?.classList.add('hidden');
    });
  });
}
